import { watch } from 'vue'
import { useRoute } from 'vue-router'

const AD_CLIENT_ID = 'ca-pub-2511625129071163'
let adScript = null
let adScriptLoaded = false

export function useAdLoader(adminRoutes = []) {
  const route = useRoute()
  
  const isAdminRoute = (path = route.path) => {
    return adminRoutes.some(adminRoute => {
      if (adminRoute.endsWith('*')) {
        return path.startsWith(adminRoute.slice(0, -1))
      }
      return path === adminRoute
    })
  }

  const loadAdScript = () => {
    if (adScriptLoaded || isAdminRoute()) return
    
    adScript = document.createElement('script')
    adScript.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${AD_CLIENT_ID}`
    adScript.async = true
    adScript.crossOrigin = 'anonymous'
    document.head.appendChild(adScript)
    
    adScriptLoaded = true
  }

  const unloadAdScript = () => {
    if (!adScriptLoaded) return
    
    // Remove the script element
    if (adScript && document.head.contains(adScript)) {
      document.head.removeChild(adScript)
    }
    
    // Clear ad slots from DOM
    document.querySelectorAll('.adsbygoogle').forEach(el => {
      el.innerHTML = ''
      el.removeAttribute('data-ad-status')
    })
    
    // Reset flags
    adScript = null
    adScriptLoaded = false
  }

  // Auto-manage ads on route change
  watch(() => route.path, (newPath) => {
    if (isAdminRoute(newPath)) {
      unloadAdScript()
    } else {
      loadAdScript()
    }
  },{immediate: true})

  return { loadAdScript, unloadAdScript, isAdminRoute }
}